import img from '../../Assets/LearningPath/web-app.png'
const WebInput = [
    {
        key : 1,
        img : img,
        title : "Advanced Front-end Development",
        btn : "Watch Videos",
        link : "/learning-path/WebDevelopment/AdvanceDevelopment",
    },
    {
        key : 2,
        img : img,
        title : "Modern Web App Development",
        btn : "Watch Videos",
        link : "/learning-path/WebDevelopment/ModernDevelopment",
    },
    {
        key : 3,
        img : img,
        title : "Hybrid Mobile App Development",
        btn : "Watch Videos",
        link : "/learning-path/WebDevelopment/ModernDevelopment",
    },
    
];
export default WebInput;